(function($) {

  var initializeBlock = function( $block ) {
    function matchHeightFire() {
      // Gradient Box cards keep their natural heights so a list sits right under its
      // title (2026-09-29); every other style keeps the equalised rows.
      var scope = '.iconGrid:not(.iconGrid--style_gradient_box) .iconItems .iconItem ';
      $(scope + '.iconItem-icon').matchHeight( {property: 'min-height'} );
      $(scope + '.iconItem-title').matchHeight( {property: 'min-height'} );
      $(scope + '.iconItem-text').matchHeight( {property: 'min-height'} );
    }
    matchHeightFire()

    $( window ).bind('resize orientationchange', function() {
      matchHeightFire();
    });

    setTimeout(function() {
      matchHeightFire();
    }, 1000)
  }

  $( document ).ready(function() {
    $('.block--icon-grid').each(function() {
      initializeBlock( $(this) );
    })
  })

  if( window.acf ) {
    window.acf.addAction( 'render_block_preview/type=icon-grid', initializeBlock );
  }

})( jQuery );
